/** User-facing login banner: credentials / access issues. */
export const INCORRECT_CREDENTIALS =
	'Incorrect email or password. Please try again.'

/** User-facing login banner: our side is unavailable. */
export const MAINTENANCE_DOWN =
	"We're currently down for maintenance. Please check back shortly."

// Semantic aliases — keep call sites readable; both map to the two banner texts.
export const ACCESS_DENIED = INCORRECT_CREDENTIALS
export const EMAIL_METHOD_UNAVAILABLE = INCORRECT_CREDENTIALS
export const GOOGLE_METHOD_UNAVAILABLE = INCORRECT_CREDENTIALS
export const SSO_METHOD_UNAVAILABLE = INCORRECT_CREDENTIALS
export const INVALID_EMAIL = INCORRECT_CREDENTIALS
export const DIFFERENT_ACCOUNT_SIGNED_IN = INCORRECT_CREDENTIALS

export const VERIFY_ACCESS_FAILED = MAINTENANCE_DOWN
export const CLERK_AUTH_FAILED = MAINTENANCE_DOWN

export const isValidCounselorEmail = value =>
	/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim())

/**
 * Evaluate counselor-auth-methods response for a selected login method.
 * Returns { ok: true, email } or { ok: false, error }.
 */
export function evaluateCounselorAuthMethods(rawEmail, method, data) {
	const email = String(rawEmail || '').trim().toLowerCase()
	if (!isValidCounselorEmail(email)) {
		return { ok: false, error: INVALID_EMAIL }
	}

	const methods = Array.isArray(data?.methods) ? data.methods : []

	if (!data?.is_counselor) {
		return { ok: false, error: ACCESS_DENIED }
	}

	if (!methods.includes(method)) {
		if (method === 'email') return { ok: false, error: EMAIL_METHOD_UNAVAILABLE }
		if (method === 'google') return { ok: false, error: GOOGLE_METHOD_UNAVAILABLE }
		if (method === 'sso') return { ok: false, error: SSO_METHOD_UNAVAILABLE }
		return { ok: false, error: ACCESS_DENIED }
	}

	return { ok: true, email, methods }
}
